import type { State } from '../../state/createInitialState';
import { PV_LAGE_BUERGER } from '../../util/pvLagenUtil';

export function buildPvLagenRequest(state: State) {
  const { pvLage } = state.search.request.filter;
  return {
    pv_lage: pvLage || PV_LAGE_BUERGER,
  };
}
